document.addEventListener("DOMContentLoaded", () => {
  $(document).on('submit', '.ajax-form', function (e) {
    const dom = $(this)
    var method = ""
    if ($(this).attr("method") == "GET") {
      method = "GET"
    } else {
      method = ($("input[name='_method']").val() == 'patch' ? "patch" : "post");
    }
    
    dom.find('button[type="submit"]').attr('disabled', 'disabled')
    dom.find("input[type='submit']").attr('disabled', 'disabled')

    e.preventDefault()
    
    $.ajax({
      url: dom.attr('action'),
      method: method,
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: dom.serialize(),
      dataType: "json",
      success: function (data) {
        hideModal()
        if (data.href != undefined && data.href != ""){
          loadPage(data.href)
        }
        if (data.message != undefined){
          Notiflix.Notify.success(data.message, {position: 'right-bottom', useIcon: false});
        }
      },
      error: function (jqXHR) {
        console.log("gagal")
        Notiflix.Notify.failure(jqXHR.responseJSON.message, {position: 'right-bottom', useIcon: false});
        dom.find('input[type="submit"]').removeAttr('disabled')
        dom.find('button[type="submit"]').removeAttr('disabled')
      },
      complete: function (res) {
        // console.log(res)
      }
    })
  })

  $(document).on('submit', '.order-form', function (e) {
    const dom = $(this)
    const total = parseInt(dom.find("[total_order_total]").text())
    
    if (total < 0) {
      alert("Total order tidak boleh minus!")
      return false
    }

    dom.find('button[type="submit"]').attr('disabled', 'disabled')

    e.preventDefault()
    
    $.ajax({
      url: dom.attr('action'),
      method: "POST",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: dom.serialize(),
      dataType: "json",
      success: function (data) {
        Notiflix.Confirm.show(
          `Berhasil membuat Order!`,
          'Lanjut ke pembayaran?',
          'Ya',
          'Tidak',
          function okCb() {
            alert('nanti muncul pop up untuk pembayaran, coming soon');
          },
          function cancelCb() {
            window.location.reload()
          },
          {},
        );
      },
      error: function (jqXHR) {
        Notiflix.Notify.failure(jqXHR.responseJSON.message, {position: 'right-bottom', useIcon: false});
        dom.find('button[type="submit"]').removeAttr('disabled')
      },
      complete: function (res) {
        // console.log(res)
      }
    })
  })
})